import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    logo: {
      userSelect: 'none',
      display: 'flex',
      gridGap: theme.spacing(1),
      minWidth: 'max-content',
      alignItems: 'center',
      '& img': {
        height: '2.5rem',
      },
      '& h1': {
        fontSize: '2rem',
      },
    },
    tabs: {
      flex: 1,
      display: 'flex',
      height: '100%',
      maxHeight: '7.2rem',
      flexDirection: 'row',

      '& .MuiTabs-flexContainer': {
        height: '100%',
      },

      '& .MuiTabs-indicator': {
        height: '4px',
        background: theme.palette.primary.dark,
      },
      '& .MuiTab-root': {
        fontFamily: theme.typography.body2.fontFamily,
        fontWeight: theme.typography.body2.fontWeight,
        textTransform: 'none',
        width: 'max-content',
        minWidth: '0',
        padding: theme.spacing(2, 1.5),

        transition: 'filter 0.2s',
        '&:hover': {
          filter: 'brightness(0.5)',
        },
      },
    },
    buttons: {
      display: 'flex',
      flexDirection: 'row',
      gridGap: theme.spacing(1.8),
      marginRight: theme.spacing(2),
      alignItems: 'center',
      '& > button': {
        margin: 0,
        color: '#fff',
        backgroundColor: theme.palette.primary.dark,
        width: '4rem',
        height: '4rem',
        padding: 0,
        borderRadius: '50%',
      },
    },
    rightContent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    listbox: {
      maxHeight: '240px',
      '& li > .MuiAutocomplete-groupLabel': {
        fontFamily: theme.typography.body1.fontFamily,
        color: '#001D29',
        fontWeight: 600,
        fontSize: '1.4rem',
      },
      '& .MuiAutocomplete-groupUl .MuiAutocomplete-option': {
        paddingLeft: 16,
        fontFamily: theme.typography.body1.fontFamily,
        fontSize: '1.2rem',
        fontWeight: 400,
      },
    },
  }),
)
